/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Diagram delete info
 */
import { ValidateUtils } from 'app/shared/utils';

export class DiagramDeleteInfo { 
    /**
     * Flag indicating whether diagram can be deleted without warning or not
     */
    readonly warnOnDelete?: boolean;

    constructor(item?: Partial<DiagramDeleteInfo>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            warnOnDelete: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.warnOnDelete : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: DiagramDeleteInfo.isValid,
        };
    }

    static isValid(obj: DiagramDeleteInfo): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = DiagramDeleteInfo.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.warnOnDelete.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

